<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        <div class="row mb-3">
          <div class="col-md-3"><h5>Edit {{type}} Profile</h5></div>
          <div class="col-md-9">
            <change-password></change-password>
            </div>
        </div>

        <div class="card mt-2">
          <div class="card-body p-0">
            <div v-if="loading" class="text-center py-3">   
      <div class="py-2"><i class="fas fa-spinner fa-spin fa-3x"></i></div>
      </div>
            <div v-else class="col">
              <div class="p-2">
                <!-- row 1 -->
                  <div class="row mt-2">
                  <div class="col-md-6">
                    <label class="form-label mr-2" for="endpoint">Business or Personal Name</label>
                    <input type="text" class="form-control dt-full-name" v-model.trim="company_name" maxlength="90"/>
                  </div>

                  <div class="col-md-6">
                    <label class="form-label mr-2" for="endpoint">Website</label><small> (optional)</small>
                    <input type="text" class="form-control dt-full-name" v-model.trim="website" maxlength="90"/>
                  </div>
                  </div>

                  <!-- row 2 -->
                  <div class="row mt-1">
                  <div class="col">
                    <label class="form-label mb-0" for="endpoint">Description</label>
                    <div class="mb-2"><small>A brief overview of who you are and what services you offer.</small></div>
                    <textarea 
                    class="form-control shadow-none inputbox" 
                    rows="5" 
                    placeholder="" 
                    v-model="description"></textarea>
                  </div>

                  </div>

                </div>

                <div class="col px-2 pt-2 pb-4">
                <button v-if="submitting" class="btn btn-success col">
                <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>Saving profile ...</button>
                <button v-else type="submit" @click="saveForm()" class="btn btn-danger col">Save Profile</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
 
</template>

<script>
import "vue-select/dist/vue-select.css";

export default {
  props: ['type'],
  data() {
    return {
      user: {},
      name: "",
      surname: "",
      email: "",
      company_name: "",
      submitting: false,
      submitted: false,
      submitStatus: null,
      loading: false,
    };
  },

  created() {
    this.getUserInfo();
  },

  methods: {

    getUserInfo() {

      this.loading = true;

      axios
        .post("/profile/getinfo")
        .then((response) => {
          this.user = response.data;
          this.name = this.user.name,
          this.surname = this.user.surname,
          this.email = this.user.email,
          this.company_name = this.user.company_name,
          this.website = this.user.website,
          this.description = this.user.description,
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },

    saveForm() {
      
      if (this.company_name == "") {
        this.sweetfire("Please enter your business or personal name");
        return;
      } else if (this.description == "") {
        this.sweetfire("Please enter a description");
        return;
      } else {

        this.submitting = true;

        this.saveProfile();

      }

    },

    saveProfile() {
      axios
        .post("/profile/save", {
          company_name: this.company_name,
          website: this.website,
          description: this.description,
          type: this.type,
        })
        .then((response) => {
          window.open("/profile", "_self");
        })
        .catch(function (error) {
          console.log(error);
          this.submitting = false;
        });
    },

        sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },

  },
};
</script> 

<style scoped>
input, button, input:focus {border-radius:5px !important;}
</style>